import * as $ from 'jquery';
import 'summernote';
import 'summernote/dist/summernote-bs4.css';
import 'summernote/dist/summernote-bs4.js';
import 'summernote/dist/lang/summernote-ar-AR';

export default (function () {
  $('.summernote').summernote({
    height: 300,
    dialogsFade: true,
    lang: "ar-AR",
    maximumImageFileSize: 524288, //512KB

    callbacks: {
      onImageUploadError: function () {
        alert(" لا يمكن اضافة صورة بحجم أكبر من 512KB ");
        //$(".note-status-output").html('<div class="alert alert-danger">' + ' لا يمكن اضافة صورة بحجم أكبر من 512KB ' + '</div>');
      }
    },

    toolbar: [
      [ 'insert', [ 'picture', 'link' ] ],
      [ 'font', [ 'bold' ] ],
      [ 'para', [ 'ul', 'ol', 'paragraph' ] ],
      [ 'view', [ 'undo', 'redo', 'fullscreen', 'codeview' ] ],
    ],
  });
}())
